//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Annotations/Annotations.HatchFillSettingsBuilder.js";
import "../Drawings/Drawings.SelectDraftingView.js";
import "../no/Annotations.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"Amplitude",0,"Expression",0],[0,"BreakLine1Anchor",1,"Point",0],[0,"BreakLine1ModelAnchor",1,"Point",0],[1,"BreakLine1Offset",0,"Expression",0],[0,"BreakLine2Anchor",1,"Point",0],[0,"BreakLine2ModelAnchor",1,"Point",0],[1,"BreakLine2Offset",0,"Expression",0],[0,"BreakLineType",1,0],[0,"BreakType",1,0],[0,"BreakVisibility",1,0],[0,"Color",1,0],[1,"CrossHatch",0,"Annotations.HatchFillSettingsBuilder",0],[0,"DirectionType",1,0],[0,"DirectionVector",1,"Direction",0],[0,"ExistingCurve",0,"ScCollector",0],[1,"Extension1",0,"Expression",0],[1,"Extension2",0,"Expression",0],[1,"Gap",0,"Expression",0],[0,"IsBreakLine1Associative",1,0],[0,"IsBreakLine2Associative",1,0],[1,"MasterView",0,"Drawings.SelectDraftingView",0],[0,"Repetition",1,0],[0,"Suppress",1,0],[0,"Width",1,0]],[],[]];
SPLM.Drawings.BrokenViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.BrokenViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.BrokenViewBuilder.TypeBreak = Object.freeze({
    "Regular" : "Regular", "SingleSided" : "SingleSided"});

SPLM.Drawings.BrokenViewBuilder.TypeDirection = Object.freeze({
    "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "Vector" : "Vector"});

SPLM.Drawings.BrokenViewBuilder.VerticalBreakSide = Object.freeze({
    "TopEnd" : "TopEnd", "BottomEnd" : "BottomEnd"});

SPLM.Drawings.BrokenViewBuilder.HorizontalBreakSide = Object.freeze({
    "LeftEnd" : "LeftEnd", "RightEnd" : "RightEnd"});

SPLM.Drawings.BrokenViewBuilder.BreakLineStyle = Object.freeze({
    "Simple" : "Simple", "Straight" : "Straight", "Sawtooth" : "Sawtooth", "LongBreak" : "LongBreak", "Tubular" : "Tubular", "SolidTubular" : "SolidTubular", "SolidRod" : "SolidRod", "Jigsaw" : "Jigsaw", "Wood" : "Wood", "CopyCurve" : "CopyCurve", "TemplateCurve" : "TemplateCurve"});

SPLM.Drawings.BrokenViewBuilder.LineWidth = Object.freeze({
    "Thin" : "Thin", "Medium" : "Medium", "Thick" : "Thick", "WidthOne" : "WidthOne", "WidthTwo" : "WidthTwo", "WidthThree" : "WidthThree", "WidthFour" : "WidthFour", "WidthFive" : "WidthFive", "WidthSix" : "WidthSix", "WidthSeven" : "WidthSeven", "WidthEight" : "WidthEight", "WidthNine" : "WidthNine"});

export default SPLM;